import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Select } from 'shared/ui/Select';
import { ContractApplicabilityFilter, CreditNotesListFilterKeys } from '../../model/types';

interface ApplicabilitySelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const ApplicabilitySelect: FC<ApplicabilitySelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const applicabilityOptions = useMemo<Array<{ label: string; value: ContractApplicabilityFilter }>>(() => {
    return [
      { label: t('Applicable'), value: ContractApplicabilityFilter.APPLICABLE },
      { label: t('Inapplicable'), value: ContractApplicabilityFilter.INAPPLICABLE },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(CreditNotesListFilterKeys.isApplicable);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Applicability')}
      placeholder={t('All')}
      bordered
      allowClear
      options={applicabilityOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
